import { classes, getEnvString } from 'src/utils'
import { Anchor, Paragraph } from '../Typography'

type Props = {
  className?: string
}

export default function EmailHelpBox(props: Props) {
  return (
    <Paragraph className={classes('col-span-full', props.className)}>
      If you're having trouble during the setup, please consult our{' '}
      <Anchor href={getEnvString('REACT_APP_HELP_URL')} target="_blank">
        help center{' '}
      </Anchor>
      or reach out to us at:{' '}
      <Anchor href="mailto:mc.notifications@idealsystems.be">
        mc.notifications@idealsystems.be
      </Anchor>
      .
    </Paragraph>
  )
}
